'use client'

import {FloatButton} from 'antd'
import {ChevronUp} from 'lucide-react'
import {observer} from 'mobx-react'

import {useLayoutStore} from './provider'

export const BackTop = observer(() => {
  const store = useLayoutStore()
  if (store.ui.mobile.menu.opened) return null

  return <FloatButton.BackTop duration={0} tooltip="Наверх" icon={<ChevronUp size={18} />} style={{bottom: '50vh'}} />
})
